
// const componentFilterMenu	= require('../components/component-filter-menu/component-filter-menu.config.js');
const componentFilterMenu	= require('../../components/component-filter-menu/component-filter-menu.config');
module.exports = {
	title: 'Sökresultat',
	bacon:'test',
	context: {
		title: 'Sökresultat',
		componentFilterMenu: 	componentFilterMenu.context
	}
};
